import { gql } from "@apollo/client";

/**
 * Fetch footer_config from the current user's tenant.
 * Returns a JSON string that the editor parses client-side.
 */
export const GET_FOOTER_CONFIG = gql`
  query FooterConfig {
    currentTenant {
      id
      name
      domain
      footerConfig
      chromeConfigDraft
      chromeConfigPublished
      socialLinks
      phone
      email
      addresses
      legalEntityName
      legalDisclaimers
      logoUrl
      footerLogoUrl
    }
  }
`;
